import React from "react";
import ProjectGrid from "./ProjectGrid";
import ProjectHeader from "./ProjectHeader";
import { toast, ToastContainer } from "react-toastify";

function ProjectBoard() {
  const notify = (msg) => toast.warn(msg);
  const projectStates = [
    { state: "BackLog", id: 1 },
    { state: "Ready", id: 2 },
    { state: "Doing", id: 3 },
    { state: "Review", id: 4 },
    { state: "Blocked", id: 5 },
    { state: "Done", id: 6 },
  ];
  return (
    <>
      <ProjectHeader />
      <div className="flex flex-grow px-10 mt-4 space-x-6 overflow-auto">
        {projectStates.map((projectState, index) => (
          <ProjectGrid
            key={projectState.id}
            projectState={projectState.state}
            id={projectState.id}
            notify={notify}
          />
        ))}
      </div>
    </>
  );
}

export default ProjectBoard;
